import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';

import React from 'react';

import { COPY } from '@/shared/constants/copies';

export type WorkspaceAccessStatusState = 'loading' | 'success' | 'error';

type WorkspaceAccessStatusProps = {
	status: WorkspaceAccessStatusState;
	// Loading
	loadingTitle?: string;
	loadingDescription?: string;
	// Success
	workspaceName?: string | null;
	isAlreadyMember?: boolean | null;
	successDescription?: string;
	// Error
	errorDescription?: string;
	errorAction?: React.ReactNode;
};

export function WorkspaceAccessStatus({
	status,
	loadingTitle,
	loadingDescription,
	workspaceName,
	isAlreadyMember,
	successDescription,
	errorDescription,
	errorAction,
}: WorkspaceAccessStatusProps) {
	return (
		<div className="flex flex-col items-center gap-4 py-4 text-center">
			<div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted">
				{status === 'loading' ? (
					<Loader2 className="h-7 w-7 animate-spin text-muted-foreground" />
				) : status === 'success' ? (
					<CheckCircle2 className="h-7 w-7 text-green-500" />
				) : (
					<AlertCircle className="h-7 w-7 text-destructive" />
				)}
			</div>

			{status === 'loading' && (loadingTitle || loadingDescription) && (
				<div>
					{loadingTitle && <p className="font-semibold">{loadingTitle}</p>}
					{loadingDescription && (
						<p className={`text-sm text-secondary ${loadingTitle ? 'mt-1' : ''}`}>
							{loadingDescription}
						</p>
					)}
				</div>
			)}

			{status === 'success' && (
				<>
					<div>
						{workspaceName ? (
							<p className="font-semibold">{workspaceName}</p>
						) : (
							<p className="font-semibold">
								{isAlreadyMember ? 'Welcome back!' : "You're in!"}
							</p>
						)}
						<p className="mt-1 text-sm text-secondary">
							{isAlreadyMember ? COPY.referrals.alreadyMember : COPY.referrals.addedToWorkspace}
						</p>
					</div>
					{successDescription && (
						<p className="text-sm text-secondary">{successDescription}</p>
					)}
				</>
			)}

			{status === 'error' && (
				<>
					<div>
						<p className="font-semibold">{COPY.access.accessDeniedTitle}</p>
						{errorDescription && (
							<p className="mt-1 text-sm text-secondary">{errorDescription}</p>
						)}
					</div>
					{errorAction}
				</>
			)}
		</div>
	);
}
